import model from "./model.js"
var get_loading = function () {
  let reload1 = null;
  let reload2 = null;
  let mask = $('#mask')
  let loading1 = $('#loading1')
  if (JSON.stringify(mask) != '{}' || JSON.stringify(loading1) != '{}') {
    $('#mask').remove()
    $('#loading1').remove()
  }
  
  return {
    loading: function (id) {
      $('#mask').remove()
      $('#loading1').remove()
      let num = 10;

      let str = '<div id="mask" class="global_loading_mask"></div>' +
        '<div class="global_loading_mask_fixed-container" id="loading1">' +
        '<div class="loading1-text">' +
        '<span>为每一片幕墙提供专业保障</span>' +
        ' </div>' +
        '<div class="fixed-bg loading1-bg"></div>' +
        '<div class="loading1-icon">' +
        '<div class="loading1-icon-text">模型加载中…' +
        '<p style="margin-top:20px;"><span id="reload1" style="color:#ffffff; font-size: 16px; border:1px solid #fff; border-radius: 50px; padding: 5px 50px; display:none;cursor: pointer;" onclick="reloadFunction()">重新加载</span></p></div>' +
        '<div id="loading1-div" class="wrap_loading">' +
        '<div class="circle">' +
        '<div class="percent left"></div>' +
        '<div class="percent right wth0"></div>' +
        '</div>' +
        '<div class="progress-num"><span id="progress1">1</span></div>' +
        '</div>' +
        '</div>'
      if (id == 'node') {
        $('#node-model').append(str)
      } else {
        $('body').append(str)
      }

      let progress = 1;
      // if (reload1) {
        clearInterval(reload1)
      // }
      reload1 = setInterval(function () {
        // let progress = parseInt($('#progress1').html());
        
        console.log('num', num, 'progress -- ', progress)
        if (progress < num) {
          progress += 1;
          // $('#progress1').html(progress)
          $('#progress1').text(progress)
          turnAround(progress)
          // if (has3DModel === true || noPhoto === true) {
          //     window.get_loading.remove_loading()
          // }
        } else {
          console.log('going to remove')
          clearInterval(reload1)
          progress = 1
          $('#reload1').show()
          window.get_loading.remove_loading()
          if (id == 'live-action' || id == 'node') {
            $('#loading1-div').remove()
            // window.get_loading.remove_loading()
          } else {
            
            $('#loading1-div').remove()
          }
          $('#progress1').text('1')
          
        }
      }, 1000)
    },
    remove_loading: function () {
      console.log('remove_loading --- 1111')
      // return
      clearInterval(reload1)
      $('#mask').fadeOut(1500)
      $('#loading1').fadeOut(1500)
      
      // setTimeout(function () {
      //   // $('#mask').remove()
      //   // $('#loading1').remove()

      //   $('.global_loading_mask').remove()
      //   $('.global_loading_mask_fixed-container').remove()
      // }, 1600)

    }
  }
}
export default get_loading

function turnAround(sec) {
  if (sec > 5) {
    $('.wrap_loading .circle').addClass('clip-auto');
    $('.wrap_loading .right').removeClass('wth0');
  }
  $('.wrap_loading .left').css("-webkit-transform", "rotate(" + 36 * sec + "deg)");
  $('.wrap_loading .progress-num>span').text(sec);
}
window.reloadFunction = function () {
  //window.vid = '5b546b1855f6b50f2873601c';
  $('#mask').remove()
  $('#loading1').remove()
  window.get_loading.loading();
  model.switchThree3D().then(() => {
    console.log("精细模型加载完")
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/loading.js